import gql from 'graphql-tag'

export default gql`mutation updateUser($data: UserInput!){
  updateUser(user: $data){
    user_id
    first_name
    last_name
    email
    user_role_id
    standard_hours_work_per_week
    active
    line_manager_user_id
    office_id
    login_id
    login{
      login_id
      username
    }
    date_created
    standard_hours_leave_allowance
    included_in_unallocated_days_report
    mobile
    phone_number
    timesheet_entry_required
    display_in_scheduler
    annual_leave_rollover_days
    current_year_annual_leave_remaining
    permissions{
      permission_id
      name
      access
    }
    undertime_weeks{
      week_commencing
      total_minutes_worked
    }
    user_role_history{
      id
      user_role{
        user_role_id
        description
      }
      active_from
    }
  }
}`